var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseNofilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5504 0.449902C14.1504 0.0499023 13.5504 0.0499023 13.1504 0.449902L7.50039 6.0999L1.85039 0.449902C1.45039 0.0499023 0.850391 0.0499023 0.450391 0.449902C0.0503906 0.849902 0.0503906 1.4499 0.450391 1.8499L6.10039 7.4999L0.450391 13.1499C0.0503906 13.5499 0.0503906 14.1499 0.450391 14.5499C0.650391 14.7499 0.900389 14.8499 1.15039 14.8499C1.40039 14.8499 1.65039 14.7499 1.85039 14.5499L7.50039 8.8999L13.1504 14.5499C13.3504 14.7499 13.6004 14.8499 13.8504 14.8499C14.1004 14.8499 14.3504 14.7499 14.5504 14.5499C14.9504 14.1499 14.9504 13.5499 14.5504 13.1499L8.90039 7.4999L14.5504 1.8499C14.9504 1.4499 14.9504 0.799902 14.5504 0.449902Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNofilter);
export default __webpack_public_path__ + "static/media/close_nofilter.fc82047a.svg";
export { ForwardRef as ReactComponent };